import React from "react";
import { Modal } from "react-bootstrap";
import { Button, CloseButton } from "components";
import MultilineTitle from "../components/multilineTitle";
import styles from "./confirmationModal.module.scss";

const ConfirmationModal = ({
	title,
	show,
	onHide,
	onConfirm,
	buttonCancel = "Cancel",
	buttonOk = "Yes",
	dialogAs,
	backdrop,
}) => {
	const handleOk = async e => {
		try {
			e.persist();
			await onConfirm(e);
		} finally {
			if (!e.isDefaultPrevented()) onHide();
		}
	};

	return (
		<Modal
			className={styles.confirmationPopup}
			show={show}
			onHide={onHide}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
		>
			<Modal.Header className={styles.header}>
				<MultilineTitle title={title} className={styles.title} />
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Footer className={styles.footer}>
				<Button
					onClick={onHide}
					value={buttonCancel}
					variant="outline-primary"
					className="mr-4"
				/>
				<Button onClick={e => handleOk(e)} value={buttonOk} />
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmationModal;
